module.exports = __webpack_public_path__ + "static/media/spices_over_food_getty_mobile.189d4e40.jpg";